<div class="page-content page-content-full">
  <iframe [src]="safeResourceUrl" width="100%" height="100%" [title]="pageName"></iframe>
</div>
